import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import './index.scss'

/**
 * Tooltip component to indicate that a work is in overclaim. Used in the catalog and
 * reg history when a work is in overclaim, and in the overclaim header.
 * Jira ticket: MPOR-3325 was created to consolidate all the tooltip components into one directory
 * @constructor
 */
const OverclaimToolTip = () => (
    <>
        <CustomToolTip type="i" place="top" info={<>This work is in overclaim</>} />
        <div className="overclaim-text">This work is in overclaim</div>
    </>
)

export default OverclaimToolTip
